<template>
  <div>
    <pg-mainshell :h1Title="h1Title">
      <el-container>
        <ir-slider style="width:100%;">
          <el-main>
            <el-form ref="form" :model="form" label-position="left" label-width="100px" v-if="loadData">
              <el-form-item :label="urlMsg.txt" label-width="200px">
                <el-input v-model="urlMsg.url"></el-input>
              </el-form-item>
              <el-form-item :label="item.name + '环节简历应聘ID'" label-width="200px" v-for="item in datalist" :key="item.code">
                <el-input v-model="item.value" @input="handleValChange($event, item)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="" @click="handleSave()" style="width:200px">保存</el-button>
              </el-form-item>
            </el-form>
          </el-main>
        </ir-slider>
      </el-container>
    </pg-mainshell>
  </div>
</template>

<script>
import PgMainshell from '../../components/PgMainShell'
import IrSlider from '../../components/IrSlider'
import constant from '../../utils/constant'

export default {
  data () {
    return {
      h1Title: '系统配置',
      form: {
        name: ''
      },
      applystatusList: [],
      recruitType: [],
      config: {},
      datalist: [],
      loadData: false,
      urlMsg: {
        txt: '接口服务地址',
        url: ''
      },
      valFocus: ''
    }
  },
  created: function () {
    this.initData()
  },
  methods: {
    async initData () {
      await this.getApplyStatusApi()
      await this.getSystemConfigApi()
      await this.initDataList()
    },
    initDataList () {
      // 接口服务地址
      this.urlMsg.url = typeof (this.config.apiUrl) === 'undefined' ? '' : this.config.apiUrl
      // xx环节简历应聘ID
      let datalist = []
      for (let itemAs in this.applystatusList) {
        let tmp = this.applystatusList[itemAs]
        this.applystatusList[itemAs].value = this.config['applyId_' + this.applystatusList[itemAs].code]
        datalist.push(tmp)
      }
      this.datalist = datalist
      this.loadData = true
    },
    async getApplyStatusApi () {
      let that = this
      that.applystatusList = []
      await this.$api.systemConfig.applyStatusApi()
        .then(function (res) {
          that.applystatusList = res.data.data
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    handleSave () {
      let params = [{
        name: 'apiUrl',
        value: this.urlMsg.url
      }]

      for (let index in this.applystatusList) {
        params.push({
          name: 'applyId_' + this.applystatusList[index].code,
          value: this.applystatusList[index].value
        })
      }
      this.getSaveConfigApi(params)
    },
    async getSystemConfigApi () {
      let that = this
      await this.$api.systemConfig.systemConfigApi()
        .then(function (res) {
          that.config = res.data.data.config
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    handleValChange (e, item) {
      this.$forceUpdate()
      let index = this.datalist.indexOf(item)
      let tmp = item
      this.datalist.splice(index, 1, tmp)
    },
    handleBlurSave (e, applyId, val) {
      this.$forceUpdate()
      let params = [{
        'name': applyId,
        'value': val
      }]
      if (applyId !== '' && val !== '' && val !== this.valFocus) {
        this.getSaveConfigApi(params)
      }
    },
    async getSaveConfigApi (params) {
      await this.$api.systemConfig.saveConfigApi(JSON.stringify(params))
        .then(function (res) {
          if (res.data.msg === '成功') {
            constant.giveMessage('保存成功！', 'success')
          }
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    }
  },
  components: {
    PgMainshell,
    IrSlider
  }
}
</script>

<style scoped>
/* 撑开容器 */
.el-aside>div,
.el-main>div{
  height: 100%;
}
.el-container,.el-scrollbar{
  width: 100%;
  height: 100%;
}
.el-container /deep/ .scroll{
  background: #fff;
  height: auto;
}
.el-main{
  overflow: hidden;
}
h2{
  width: 100%;
  height: 25px;
  padding-left: 30px;
  padding-bottom: 24px;
  text-align: left;
  font: Bold 18px/21px Microsoft YaHei;
  letter-spacing: 0px;
  color: #445870;
  opacity: 1;
}
.el-form-item{
  padding-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/containers/SystemConfig/Index.vue